import type { ReactNode } from 'react';

export const symbol_arrow_shape_up_stack: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M363-190v-94H213q-15 0-21-13.5t4-24.5l263-281q8.75-10 21.88-10Q494-613 503-603l263 281q10 11 4 24.5T749-284H598v94q0 12.75-8.62 21.37Q580.75-160 568-160H393q-12.75 0-21.37-8.63Q363-177.25 363-190Zm60-30h115v-94q0-12.75 8.63-21.38Q555.25-344 568-344h94L481-538 300-344h93q12.75 0 21.38 8.62Q423-326.75 423-314v94Zm58-524L253-500q-5 5-10 7.5t-12 2.5q-20.47 0-28.73-18.5Q194-527 208-542l251-268q8.75-10 21.88-10Q494-820 503-810l251 269q14 15 5.73 33-8.26 18-28.73 18-7 0-12-2.5t-10-7.5L481-744Zm0 400Z"
		/>
	</svg>
);
